import { Injectable } from '@angular/core'
import { GridModel, paginationModel, LoadOptModel, EventModel, LoadFltModel } from './grid.model'
import { AjaxService } from 'src/app/shared/ajax.service'
import { CmodalService } from '../cmodal/cmodal.service'
import { AlerterService } from 'src/app/shared/alerter.service'
import { PipsPipe } from '../../shared/pips.pipe'
import { UtilService } from 'src/app/shared/util.service'
import { ColumnModel } from './column/column.model'
import { GlobService } from 'src/app/shared/glob.service'
import { DomSanitizer } from '@angular/platform-browser'
import { CmodalModel } from '../cmodal/cmodal.model'
import { PageService } from '../../page/page.service'

@Injectable({
  providedIn: 'root'
})

export class GridService {
  components: any[]
  inuse: boolean
  thos: any = this
  alphabet: any = ['ا', 'ب', 'پ', 'ت', 'ث', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی', 'آ']
  constructor(private glob: GlobService, private util: UtilService, private pservice: PageService, private cmodalService: CmodalService, private sanitized: DomSanitizer, private pip: PipsPipe, private alerter: AlerterService, private ajax: AjaxService) { }

  async init(model: GridModel) {
    var thos = this
    model.dats = []
    if (model.codc)
      await eval("(async () => {" + model.codc + "})()")

    if (model.id == '2019010209175788315') {
      document.getElementById('2019010209175788337').removeEventListener('row_click', undefined)
      document.getElementById('2019010209175788337').addEventListener('row_click', function (e: any) {
        this.load(model, [{ als: 'tnam', val: e.detail.model.dats_vis[e.detail.i][1], mod: 1 }], null, null, (dats) => {
          model.dats = dats
          model.pagination = new paginationModel(10)
          this.pager(model, 1)
        })
      })

      document.getElementById('2019010209175788315').removeEventListener('row_edit_grid', undefined)
      document.getElementById('2019010209175788315').addEventListener('row_edit_grid', function (e: any) {
        let mdl = e.detail.model
        mdl.cols[3].edt = true
        switch (mdl.dat_edt_tmp[2]) {
          case 'boolean':
            mdl.cols[2].opts = [{ i: 'character varying', t: 'character varying' }, { i: 'character', t: 'character' }, { i: 'boolean', t: 'boolean' }]
            mdl.cols[3].edt = false
            break
          case 'smallint':
          case 'integer':
          case 'bigint':
          case 'real':
          case 'double precision':
          case 'decimal':
            mdl.cols[2].opts = [{ i: 'smallint', t: 'smallint' }, { i: 'integer', t: 'integer' }, { i: 'bigint', t: 'bigint' }, { i: 'real', t: 'real' }, { i: 'double precision', t: 'double precision' }, { i: 'decimal', t: 'decimal' }]
            mdl.cols[3].edt = false
            break
          case 'character varying':
          case 'character':
            mdl.cols[2].opts = [{ i: 'character varying', t: 'character varying' }, { i: 'character', t: 'character' }]
            break
        }
      });

      document.getElementById('2019010209175788315').removeEventListener('row_add_grid_befor', undefined)
      document.getElementById('2019010209175788315').addEventListener('row_add_grid_befor', function (e: any) {
        let mdl = e.detail.model
        mdl.cols[3].edt = true
        mdl.cols[2].opts = [{ i: 'character varying', t: 'character varying' }, { i: 'character', t: 'character' }, { i: 'smallint', t: 'smallint' }, { i: 'integer', t: 'integer' }, { i: 'bigint', t: 'bigint' }, { i: 'boolean', t: 'boolean' }, { i: 'real', t: 'real' }, { i: 'double precision', t: 'double precision' }, { i: 'decimal', t: 'decimal' }];
      });
    }

    if (model.lod)
      this.load(model, null, null, null, (dats) => {
        model.dats = dats
        model.pagination = new paginationModel(model.psiz)
        this.pager(model, 1)
      })

    let t: any = $('#' + model.id + ' *[data-bs-toggle="tooltip"]')
    // t.tooltip(glob.hmode ? 'enable' : 'disable')
    // let t: any = $('*[data-toggle="tooltip"]')
    t.tooltip('enable')
  }

  request_json(model: GridModel, flts?: LoadFltModel[], dyn?: any, opt?: LoadOptModel) {
    if (!flts) flts = []
    if (!dyn) dyn = {}
    if (!opt) opt = new LoadOptModel()

    let _flts = []
    if (opt.with_filter)
      _flts = model.cols.filter(x => (x.flt.mod != 3 && x.flt.val) || (x.flt.mod == 3 && (x.flt.val[0] || x.flt.val[1])) || x.flt.mod == 11 || x.flt.mod == 12).map((x) => {
        let v = x.flt.val
        if (x.cmp == 6) {
          if (x.flt.mod != 3)
            v = this.caldate(x.flt.val, x.cnf.config.format_out)
          else
            v = this.caldate(x.flt.val[0], x.cnf.config.format_out) + '◙' + this.caldate(x.flt.val[1], x.cnf.config.format_out)
        }
        return { als: x.vals, val: v, mod: x.flt.mod }
      })

    for (let f of flts)
      _flts.push(f)

    if (model.pars)
      for (let par of model.pars) {
        if (par[3] == 'true') _flts.push({ als: par[0], val: par[4], mod: 2 })
      }

    return { flts: _flts, dyn, opt }
  }

  load_assign(model: GridModel, flts?: LoadFltModel[], dyn?: any, opt?: LoadOptModel, callback?: any) {
    this.load(model, flts, dyn, opt, (dats) => {
      model.dats = dats
      model.pagination = new paginationModel(model.psiz)
      this.pager(model, 1)
      if (callback) callback(dats)
    })
  }

  load(model: GridModel, flts?: LoadFltModel[], dyn?: any, opt?: LoadOptModel, callback?: any) { // mod (1).replace, 2.update, 3.add
    if (!flts) flts = []
    if (!dyn) dyn = {}
    if (!opt) opt = new LoadOptModel()

    if (model.pars && model.pars.find(x => x.length == 4)) return
    if (opt.edit_cancel && model.sta != 1) this.edit_cancel(model)
    if (model.cols.length == 0) { this.alerter.warning('ستون های گرید تعریف نشده اند.'); return }
    // $('#' + model.id).find('input:checkbox:checked').prop('checked', false);

    let data = this.request_json(model, flts, dyn, opt)
    if (model.sela == 2 || model.sela == 3) model.dats_vis = []
    model.loading = true
    this.ajax.execute({
      url: 'grid/load/' + model.id,
      data: data,
      success: (post: any) => {
        if (data.opt.apply) {
          if (callback) callback(post)
        }
        else {
          let dats = post.result
          // for (let i = 0; i < dats.length; i++) dats[i] = dats[i]
          model.dat_foc = null
          for (let comp of this.components) {
            if (comp.model === model) continue
            if (comp.model.pars) {
              for (let par of comp.model.pars) {
                if (par[1] == model.id) {
                  comp.model.dats = []
                  comp.model.pagination = new paginationModel(model.psiz)
                  this.pager(comp.model, 1)
                  comp.model.sql = null
                }
              }
            }
          }
          let sel_i = this.cidx(model, 'sel')
          if (model.sela != 1 && sel_i != -1)
            for (let i = 0; i < post.result.length; i++) post.result[i][sel_i] = (post.result[i][sel_i] === 'true' ? true : false)

          this.sumfoot(model, dats)
          if (callback) callback(dats)
          setTimeout(() => {
            if (document.getElementById(model.id)) document.getElementById(model.id).dispatchEvent(new CustomEvent('grid_load_after', { detail: { model } }))
          }, 500);
        }
      },
      complete: () => { model.loading = false }
    })
  }

  last_limit(model: GridModel) {
    this.load_assign(model, null, null, { orderby: model.cols[0].tals + '.' + model.cols[0].val + ' desc', limit: 10 })
  }

  caldate = (val: any, format_out: string) => {
    if (typeof val == 'string') return val.split('-').join('').split('/').join('')
    else return val.format(format_out || 'jYYYYjMMjDD')
  }

  pattern_load_sql(model) {
    this.load_assign(model, null, null, null, (post) => {
      this.fallbackCopyTextToClipboard(post.result)
      this.alerter.info('الگوی کوئری دریافت اطلاعات گرید در کلیپ برد سیستم و کنسول مرورگر (console.log) کپی شد.')
    })
  }

  pattern_import_excel(model) {
    alert('need to programming')
  }

  pattern_request_json(model) {
    this.fallbackCopyTextToClipboard(JSON.stringify(this.request_json(model, null, null, null), null, 3))
    this.alerter.info('الگوی درخواست دریافت اطلاعات گرید به صورت JSON string در کلیپ برد سیستم و کنسول مرورگر (console.log) کپی شد.')
  }

  remove(model: GridModel, row_id: string) {
    if (!confirm('پس از حذف رکورد، امکان بازیابی وجود ندارد. مایل به حذف هستید؟')) return
    let col = model.cols.find(x => (x.vals) == 'id')
    row_id = this.switch_cmpcnf_val(col.cmp, col.cnf, row_id)
    this.ajax.execute({
      url: 'grid/remove',
      data: { id: model.id, row_id },
      success: (post: any) => {
        for (var i = 0; i < model.dats_vis.length; i++)
          if (model.dats_vis[i][this.cidx(model, 'id')].split('◙')[0] == post.result.id)
            model.dats_vis.splice(i, 1);

        if (model.dats_sel)
          for (var i = 0; i < model.dats_sel.length; i++)
            if (model.dats_sel[i][0].split('◙')[0] == post.result.id) model.dats_sel.splice(i, 1);

        for (var i = 0; i < model.dats.length; i++)
          if (model.dats[i][0].split('◙')[0] == post.result.id)
            model.dats.splice(i, 1);
      }
    })
  }

  status(model: GridModel, row_id: string, mode: number, no_confirm?: boolean) {
    let vis_i = null
    for (let i = 0; i < model.dats_vis.length; i++)
      if (model.dats_vis[i][0] == row_id) vis_i = i

    document.getElementById(model.id).dispatchEvent(new CustomEvent('status_change_befor', { detail: { model, mode, row_id, vis_i } }))
    if (!no_confirm && !confirm('آیا مایل به تغییر وضعیت هستید؟')) return

    if (row_id && typeof row_id == 'string') row_id = row_id.split('◙')[0]
    this.ajax.execute({
      url: 'grid/statu',
      data: { id: model.id, row_id: row_id, mode: mode },
      success: (post: any) => {
        if (mode == 1 || mode == -1)
          for (let i = 0; i < model.dats.length; i++)
            if (model.dats[i][0].split('◙')[0] == post.result.split('◙')[0]) {
              // model.dats[i][this.cidx(model, 'status')] = (parseInt(model.dats[i][this.cidx(model, 'status')]) + mode).toString()
              model.dats[i][this.cidx(model, 'status')] = post.result.split('◙')[1]
              document.getElementById(model.id).dispatchEvent(new CustomEvent('status_change_after', { detail: { model, mode, i } }))
            }
      }
    })
  }

  action_visibility_row = (model: GridModel, action_type: string, i: number) => {
    let stu
    if (model.prm.gs_grid_id) {
      if ((action_type == 'status_down' || action_type == 'status_up') && !model.cols.find(x => x.vals == 'status')) return false
      let mdl

      for (let c of this.components) { if (c.model.id == model.prm.gs_grid_id) { mdl = c.model; break } }

      for (let u = 0; u < mdl.dats.length; u++)
        if (mdl.dats[u][0] == mdl.dat_foc[0]) i = u

      stu = mdl.cols.find(x => x.vals == 'status') ? this.mapping(mdl, 'status', i) : true
    }
    else
      stu = model.cols.find(x => x.vals == 'status') ? this.mapping(model, 'status', i) : true

    let prm = model.prm[action_type]

    if ((action_type == 'status_up' || action_type == 'status_down') && stu == false) return false
    if (prm == '*') return true

    let prms = []
    if (prm == null) prms = [null]
    else prms = prm.split(',')

    return prms.find(x => x != null && x != undefined && x.split('.')[0] == stu) ? true : false
  }

  action_visibility = (model: GridModel, action_type: string) => {
    if (!model.prm || !model.prm || !model.tnam) return false
    if (action_type == 'add' && (model.prm.creating || model.prm.creating == 0) && (!model.pars || !model.pars.find(x => x.length == 4))) return true
    return false
  }

  add = (event, model: GridModel, _cform?: number) => {
    let cform_rollback = model.cform
    if (_cform != undefined) model.cform = _cform
    else model.cform = (model.disf == 5 || model.disf == 2) ? 2 : 1

    let new_dat_edt = []
    for (let i = 0; i < model.cols.length; i++) new_dat_edt.push(null)

    if (model.cform == 1) {
      if (model.pars && model.pars.find(x => x.length == 4)) return
      if (model.sta === 3) return this.edit_cancel(model)
      if (model.dats_vis == undefined) model.dats_vis = []
      model.dats_vis.push(new_dat_edt)
    }

    model.dat_edt = new_dat_edt // model.dats_vis[model.dats_vis.length - 1]
    model.dat_edt_tmp = []
    let alsz = model.cols.filter(x => (model.talses.find(y => y == x.tals) || x.tals == '*') && (x.cmp === 8 || x.cmp === 10) && x.fk.lod != -2 && (!x.fk.opts || x.fk.lod == -1)).map(x => x.cmp == 8 ? x.val.split(' ')[0] : x.vals)

    for (let i = 0; i < model.cols.length; i++) {
      model.dat_edt_tmp.push(null)
      let x = model.cols[i]
    }

    if (model.id == '2019010209175788315') {
      model.dat_edt_tmp[0] = model.dats[0][0].split(';')[0] + ';none'
      model.dat_edt_tmp[5] = 'false'
    }

    model.sta = 3
    model.row_i = 0
    console.log(1100, model.sta, model)
    if (model.cform == 1) document.getElementById(model.id + (model.cform == 1 ? '' : '1')).dispatchEvent(new CustomEvent('row_add_grid_befor', { detail: { model } }))
    if (alsz && alsz.length > 0)
      this.ajax.execute({
        url: 'grid/opts',
        data: { grid_id: model.id, alsz: alsz.join(','), witch: 'fk' },
        success: async (post: any) => {
          for (let o of post.result) {
            let col = model.cols.find(x => x.vals == o.als)
            if (col) col.fk.opts = o.lst
          }

          if (model.cform == 1) document.getElementById(model.id + (model.cform == 1 ? '' : '1')).dispatchEvent(new CustomEvent('row_add_grid', { detail: { model, cform: model.cform } }))
        }
      })
    console.log(7800, model.cform, model.disf)
    if (model.cform == 2) {
      let disf_rollback = model.disf
      model.disf = 5
      this.cmodalService.implement(model.id, { disf_rollback, cform_rollback }, null, (mdl, dat) => {
        let c = mdl.cols.find(x => ['tit', 'title', 'nam', 'name', 'als'].find(y => y == x.vals))
        let idx = this.cidx(mdl, c.vals)

        if (!idx) {
          alert('گرید انتخابی در popup ستونی نام مستعار زیر ندارد /n tit, title, nam, name, als')
          return
        }
        // this.cmodalService.hide()
        // if (c) out[ci] = dat[0][0] + '◙' + dat[0][idx]
        // else out[ci] = dat[0][0] + '◙' + dat[0][0]
      })
    }

    setTimeout(() => {
      if (event && model.cform == 1) $(event.target).closest('tr').find('input:visible, textarea:visible, select:visible:not([data-self="true"]), dp-date-picker:visible').eq(0).focus()
    }, 200)
  }

  edit = (event, model: GridModel, row_id: string, i: number, _cform: number) => {
    if (model.pars && model.pars.find(x => x.length == 4)) return

    model.dat_edt = model.dats_vis[i]
    model.dat_edt_tmp = model.dat_edt.slice()
    model.sta = 2
    model.row_i = i
    model.cform = _cform || 1
    let alsz = model.cols.filter(x => (model.talses.find(y => y == x.tals) || x.tals == '*') && (x.cmp === 8 || x.cmp === 10) && x.fk.lod != -2 && (!x.fk.opts || x.fk.lod == -1)).map(x => x.cmp == 8 ? x.val.split(' ')[0] : x.vals)
    // let permit_column_ids = []
    // for (let i = 0; i < column_ids.length; i++) {
    //   let prm = model.prm.column.find(x => x.column_id == column_ids[i])
    //   if (prm) permit_column_ids.push(prm.id)
    // }

    for (let i = 0; i < model.cols.length; i++) {
      let x = model.cols[i]
      model.dat_edt_tmp[i] = this.switch_cmpcnf_val(x.cmp, x.cnf, model.dat_edt_tmp[i])
      if ((model.talses.find(y => y == x.tals) || x.tals == '*') && (x.cmp === 8 || x.cmp === 10) && x.fk.lod == 1) x.fk.lod = 0
    }

    if (alsz && alsz.length > 0)
      this.ajax.execute({
        url: 'grid/opts',
        // data: { id: model.id, column_ids, parent_idz: (!model.pars ? null : model.pars.filter(x => x.length == 5).map(x => x[4]).join(',')), permit_column_ids, mod: 'fk' },
        data: { grid_id: model.id, alsz: alsz.join(','), witch: 'fk' },
        success: async (post: any) => {
          for (let o of post.result) {
            let col = model.cols.find(x => x.vals == o.als)
            if (col) col.fk.opts = o.lst
          }
          if (model.cform == 1) document.getElementById(model.id).dispatchEvent(new CustomEvent('row_edit_afterload', { detail: { model, row_id, i, cform: _cform } }))
        }
      })

    document.getElementById(model.id).dispatchEvent(new CustomEvent('row_edit_grid', { detail: { model, i } }))

    setTimeout(() => {
      if (model.cform == 1) $(event.target).closest('tr').find('input:visible, textarea:visible, select:visible:not([data-self="true"]), dp-date-picker:visible').eq(0).focus()
    }, 200)
  }

  insdate = (model: GridModel, dats: { als: string, val: any }[], sta: number, callback: any) => {
    let valid = this.validation(model, dats)
    if (!valid.res) return this.alerter.warning(valid.mes)
    var upload_data = this.util.data_former({ id: model.id, dats, sta }, undefined, undefined)
    for (let f of model.cols.filter(x => x.cmp == 12)) {
      let file = document.getElementById(model.id + '_' + f.vals)
      if (!file) continue
      if ((<HTMLInputElement>file).files.length > 0)
        upload_data.append('file', (<HTMLInputElement>document.getElementById(model.id + '_' + f.vals)).files[0], f.vals)
    }

    model.loading = true

    $.ajax({
      url: this.glob.host + 'grid/insdate',
      data: upload_data,
      type: 'post',
      processData: false,
      contentType: false,
      xhrFields: { withCredentials: true },
      success: (post: any) => {
        for (var i = 0; i < post.alerts.length; i++)
          switch (post.alerts[i].t) {
            case 0: this.alerter.error(post.alerts[i].m); break;
            case 1: this.alerter.warning(post.alerts[i].m); break;
            case 2: this.alerter.success(post.alerts[i].m); break;
            case 3: this.alerter.info(post.alerts[i].m); break;
            case 4: window.location.href = '/account/login'
          }
        for (let x of post.alerts)
          if (x.t == 0 || x.t == 1)
            return

        if (callback) callback(post.result)
      },
      complete: () => {
        model.loading = false
      }
    })
  }

  edit_apply = (model: GridModel, row_id: string, rowv_i: number) => {
    if (this.inuse) return
    else this.inuse = true
    setTimeout(() => { this.inuse = false }, 2000)
    console.log(330, this.inuse, model)

    if (model.sta <= 1) return
    let cols = model.cols.filter(x => (model.talses.find(y => y == x.tals) && x.tals != 'status' && x.vals != 'id') || (x.vals == 'id' && x.cmp != 1) || (x.vals == 'id' && model.sta == 2))
    let stu = this.mapping(model, 'status', model.dat_edt)
    var dats: { als: string, val: any }[] = []

    for (let c of cols) {
      // if (!model.prm.column.find(x => (x.column_id == '*' || c.id == x.column_id) && (x.statu_id == '*' || x.statu_id == null || x.statu_lev == stu || model.sta == 3))) continue
      if (c.prm && ((model.sta == 3 && c.prm.add == false) || (model.sta == 2 && c.prm.edit == false))) continue
      let v = this.mapping(model, c.vals, model.dat_edt_tmp)
      if (model.pars)
        for (let p of model.pars) {
          if (c.vals == p[0]) v = p[4]
        }

      if (c.cmp == 6) {
        let v2: any
        if (!v) v2 = null
        else if (typeof v == 'string') {
          switch (c.cnf.mod) {
            case 1: v2 = v.split('-').join('').split('/').join(''); break;
            case 2: let temp = v.split(':'); v2 = parseInt(temp[0]) * 3600 + parseInt(temp[1]) * 60 + (temp[2] ? parseInt(temp[3]) : 0); break;
          }
        }
        else {
          switch (c.cnf.mod) {
            case 1: v2 = v.format(c.cnf.config.format_out); break;
            case 2:
              if (c.cnf.config.format_out != 'sumsec') v2 = v.format(c.cnf.config.format_out);
              else {
                v2 = v.format('HH:mm:ss').split(':')
                v2 = parseInt(v2[0]) * 3600 + parseInt(v2[1]) * 60 + (v2[3] ? parseInt(v2[3]) : 0)
              }
          }
        }
        dats.push({ als: c.vals, val: !v ? null : v2 })
      }
      else if (c.cmp == 8 || c.cmp == 10 || c.cmp == 13) {
        if (v) v = v.split('◙')[0]
        console.log(90, c.cmp, v)
        dats.push({ als: c.vals, val: v })
      }

      else if (c.cmp == 12) {
        let f: any = document.getElementById(model.id + '_' + c.vals)
        if (!f) continue
        v = f.value || null

        if (f.value) {
          v = f.value + ''
          v = v.substring(v.lastIndexOf('\\') + 1)
          dats.push({ als: c.vals, val: v })
        }
      }

      else {
        // if ((c.vals) != 'id' && !model.prm.column.find(x => (x.column_id == '*' || c.id == x.column_id) && (x.statu_id == '*' || x.statu_id == null || x.statu_lev == stu || model.sta == 3))) continue
        dats.push({ als: c.vals, val: v })
      }
    }

    this.insdate(model, dats, model.sta, (res: any) => {
      if (model.sta == 3)
        if (model.id == '2019010209175788315') { model.dat_edt_tmp[0] = model.dat_edt_tmp[0].split(';')[0] + ';' + res }
        else { model.dat_edt_tmp[0] = res.id }

      for (let i = 0; i < model.cols.length; i++)
        if (model.cols[i].cmp == 8 || model.cols[i].cmp == 10 || model.cols[i].cmp == 13) model.dat_edt_tmp[i] = model.dat_edt_tmp[i] + '◙' + model.dat_edt_tmp[i]

      if (model.id == '2019010209175788337' || model.id == '2019010209175788315') {
        if (model.sta == 2)
          for (let u = 0; u < model.dats.length; u++)
            if (model.dats[u][0] == row_id) {
              model.dats[u] = model.dat_edt_tmp
              break
            }

        if (model.sta == 2)
          for (let u = 0; u < model.dats_vis.length; u++)
            if (model.dats_vis[u][0] == row_id) {
              model.dats_vis[u] = model.dat_edt_tmp
              break
            }

        if (model.sta == 3 && model.dis != 1) {
          model.dat_edt_tmp[0] = model.dat_edt_tmp[1]
          model.dats_vis[model.dats_vis.length - 1] = model.dat_edt_tmp
          model.dats.push(model.dat_edt_tmp)
        }
        if (model.cform == 1) model.sta = 1
      }
      else { // this.switch_cmpcnf_val(model.cols[row_i].cmp, model.cols[row_i].cnf, model.dat_edt_tmp[0])
        let opt = new LoadOptModel()
        opt.edit_cancel = false
        opt.with_filter = false
        let flts = []
        flts.push({ als: 'id', val: res.id, mod: 2 })
        this.load(model, flts, null, opt, (dat: any) => {

          if (dat && dat.length > 0 && model.sta == 2)
            for (let u = 0; u < model.dats.length; u++)
              if (model.dats[u][0] == dat[0][0]) {
                model.dats[u] = dat[0]
                break
              }

          if (dat && dat.length > 0 && model.sta == 2)
            for (let u = 0; u < model.dats_vis.length; u++)
              if (model.dats_vis[u][0] == dat[0][0]) {
                model.dats_vis[u] = dat[0]
                break
              }

          if (model.sta == 2 && ['2019010209175788323', '2019010209175788311', '2019010209175788312'].find(x => x == model.id)) { // ستون های گرید
            model.sql = res.sql
          }
          if (model.sta == 3 && model.dats) {
            model.dats.push(dat[0])
            if (model.cform == 1) model.dats_vis[model.dats_vis.length - 1] = dat[0]
            else if (model.cform == 2) model.dats_vis.push(dat[0])
          }
          if (model.dis == 1) model.dat_foc = dat[0]
          if (model.cform == 1) model.sta = 1
          if (model.disf == 5) this.cmodalService.unimplement()
        })
      }

      // this.cmodalService.unimplement()
      this.sumfoot(model, model.dats)

      document.getElementById(model.id + (model.cform == 2 ? '1' : '')).dispatchEvent(new CustomEvent('update_after', { detail: { model, row_id } }))
    })
  }

  edit_cancel = (model: GridModel) => {
    if (model.sta == 3 && model.cform == 1) {
      model.dats_vis.pop()
      model.dat_edt_tmp = null
    }
    model.sta = 1
    model.dat_edt = null
    this.cmodalService.unimplement()
    console.log(78800)
  }

  edit_checkbox_change = (model: GridModel, dat_edt_tmp: any[], i: number) => {
    if (dat_edt_tmp[i]) dat_edt_tmp[i] = false
    else dat_edt_tmp[i] = true
    // console.log(8,dat_edt_tmp[i])
    // if (dat_edt_tmp[i] == 'false' || dat_edt_tmp[i] == null || dat_edt_tmp[i] == '∅' || dat_edt_tmp[i] == '') dat_edt_tmp[i] = 'true'
    // else if (dat_edt_tmp[i] == 'true') dat_edt_tmp[i] = 'false'
    // console.log(dat_edt_tmp)
  }

  detail = (event: any, model: GridModel, row_id: string) => {
    let row = model.dats_vis.find(x => x[0] == row_id)
    let htm = []
    htm.push('<form class="row gy-2 gx-3 align-items-center">')
    for (let i = 0; i < row.length; i++)
      htm.push(`<div class="col-auto" style="margin-top:2rem">
    <label class="visually-hidden0" for="autoSizingInput">${model.cols[i].lbl}:</label>
    <br>
    <span style="min-width: 200px; border: solid 1px #e1e1e1; display: inline-block; background-color: white; padding: 0.4rem;">${row[i] ? row[i].toString().split('◙')[0] : '&nbsp;'}</span>
  </div>
  `)
    htm.push('</from>')
    if (model.id == '2019010209175788306')
      htm.push(`<div class="row"><div class="col"><img style="height:60px; width:initial; margin: 1rem 5rem 1rem 1rem" src="${this.glob.host}/grid/filer/p.personnel_docs/face_upl/thumb/${this.glob.session.personnel_docs_id}"></div></div>`)
    this.cmodalService.document(model.tit, htm.join('<br>'), {})
  }

  pager = (model: GridModel, page_number: any) => {
    let pg = model.pagination

    switch (page_number) {
      case 'first':
        pg.page_number = 1;
        break;
      case 'last':
        pg.page_number = Math.ceil(model.dats.length / pg.page_size);
        break;
      case 'prev':
        if (pg.page_number > 1) pg.page_number--; else return;
        break;
      case 'next':
        if (model.dats.length / pg.page_size > pg.page_number) pg.page_number++; else return;
        break;
      default:
        if (page_number) pg.page_number = page_number;
    }

    pg.pages = []
    for (var i = 0; i < model.dats.length / pg.page_size; i++)
      if (((pg.page_number - i) < 11 && (pg.page_number - i) > -9))
        pg.pages.push(i + 1)

    pg.first = (pg.page_number > 1) ? true : false
    pg.prev = (pg.page_number > 1) ? true : false
    pg.next = (pg.page_number < pg.pages.length) ? true : false
    pg.last = (pg.pages.length > pg.page_number) ? true : false
    let tmp = []
    for (var i = 0; i < model.dats.length; i++) {
      if (i >= (pg.page_size * (pg.page_number - 1)) && i < (pg.page_size * pg.page_number))
        tmp.push(model.dats[i])
    }

    model.dats_vis = tmp
  }

  update_row_dep(grid_id: string, row_id: string, tnam: string, flds: any) {
    let comps = this.components.filter(comp => comp.model.id == grid_id)
    if (!comps || comps.length == 0)
      return

    let mdl = comps[0].model
    let dat
    for (let r of mdl.dats)
      if (r[0] == row_id)
        dat = r
    if (!dat)
      return
    for (var ii = 0; ii < mdl.cols.length; ii++) {
      if (mdl.cols[ii].tnam != tnam) continue
      let fld = flds.find(x => x.nam == mdl.cols[ii].vals)
      if (fld) {
        dat[ii] = fld.val
      }
    }
  }

  export = (model: GridModel, which) => {
    var thos = this
    this.ajax.execute({
      url: 'export/get',
      data: { grid_id: model.id },
      success: (post) => {
        let expo = post.result
        let h = ''
        let f = ''

        for (let e of expo.filter(x => !x.rep))
          for (let i = 1; i < 8; i++)
            if (e['c' + i]) e.max = i

        if (model.pars) var pcomp = this.components.find(x => x.model.id == model.pars[0][1])
        if (pcomp) var pmodel = pcomp.model
        if (pcomp) var pdata = pmodel.dat_foc

        for (let e of expo)
          for (let i = 1; i <= e.max; i++)
            if (e['c' + i]) eval('e["c' + i + '"] = "' + e['c' + i].split('{(').join('" + ').split(')}').join(' + "') + '"')

        for (let e of expo.filter(x => !x.rep)) {
          let td = ''
          for (let i = 1; i <= e.max; i++)
            td += `<div class="${e['cls' + i] || 'col'}" style="${e['sty' + i] || 'text-align: center'}">` + (e['c' + i] || '') + '</div><br>'

          if (e.pos == 1)
            h += '<div class="row alert alert-secondary">' + td + '</div>'
          else
            f += '<div class="row alert alert-secondary">' + td + '</div>'
        }
        if (model.pars && model.pars.find(x => x.length == 4)) return
        if (model.cols.length == 0) { this.alerter.warning('ستون های گرید تعریف نشده اند.'); return }

        let param: any = this.request_json(model, null, null, new LoadOptModel())
        this.util.export_page({ id: model.id, tit: model.tit, dats: model.dats, cols: model.cols, header: h, footer: f }, this.pip, null, { url: this.glob.host + 'export/excel', param, nam: model.tit }, model, { which })
      }
    })
  }

  filer = (model: GridModel, ci: number, row_id: string, mod: string) => { // mod: 'self', 'thumb48'
    let callback = row_id + '_' + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds()
    return this.glob.host + 'grid/filer/' + model.tnam + '/' + model.cols[ci].vals + '/' + mod + '/' + row_id + '?callback=' + callback
  }

  filer_origin = (event: any, model: GridModel, ci: number, row_id: string, row_ext: string) => {
    let callback = row_id + '_' + new Date().getHours() + new Date().getMinutes() + new Date().getSeconds()
    let url = this.glob.host + 'grid/filer/' + model.tnam + '/' + model.cols[ci].vals + '/org/' + row_id + '?callback=' + callback
    // var win = window.open(url, '_blank')
    // win.focus()

    var link = document.createElement('a');
    link.href = url;
    link.target = 'blank'
    link.download = 'download' //url.substr(url.lastIndexOf('/') + 1);
    link.click();

  }

  row_click(model: GridModel, i: number) {
    switch (model.sta) {
      case 1:
        model.dat_foc = model.dats_vis[i]
        for (let comp of this.components) {
          if (comp.model === model || !comp.model.pars) continue
          let pars = comp.model.pars.filter(x => x[1] == model.id)
          if (!pars || pars.length == 0) continue
          for (let par of pars) {
            if (par.length == 4) par.push(this.mapping(model, par[2], i).toString().split('◙')[0])
            else par[4] = this.mapping(model, par[2], i).toString().split('◙')[0]
          }
          if (comp.ctyp == 'grid' && comp.model.pars.find(x => x.length != 5 || x[3] == 'false') == undefined) {
            this.load(comp.model, null, null, null, (dats) => {
              comp.model.dats = dats
              comp.model.pagination = new paginationModel(comp.model.psiz)
              this.pager(comp.model, 1)
            })
          }
        }
        document.getElementById(model.id).dispatchEvent(new CustomEvent('row_focus', { detail: { model, i } }))
        break
      // case 2:
      //   model.dat_edt = model.dats_vis[i]
      //   model.dat_edt_tmp = model.dat_edt.slice() //.join('ö').split('ö')
      //   for (let i = 0; i < model.cols.length; i++) {
      //     let col = model.cols[i]
      //     // if (col.cmp == 8 || col.cmp == 10)
      //     //   model.dat_edt_tmp[i] = model.dat_edt_tmp[i].split('◙')[0]
      //     // else if (col.cmp == 6) {
      //     //   if (col.cnf.mod == 1) model.dat_edt_tmp[i] = model.dat_edt_tmp[i] == '∅' ? null : this.pip.date(parseInt(model.dat_edt_tmp[i])).toString()
      //     //   if (col.cnf.mod == 2) model.dat_edt_tmp[i] = model.dat_edt_tmp[i] == '∅' ? null : this.pip.time(parseInt(model.dat_edt_tmp[i])).toString()
      //     //   if (col.cnf.mod == 3) model.dat_edt_tmp[i] = model.dat_edt_tmp[i] == '∅' ? null : this.pip.datetime(model.dat_edt_tmp[i]).toString()
      //     //   if (col.cnf.mod == 4) model.dat_edt_tmp[i] = model.dat_edt_tmp[i] == '∅' ? null : this.pip.month(parseInt(model.dat_edt_tmp[i])).toString()
      //     // }
      //     model.dat_edt_tmp[i] = this.switch_cmpcnf_val(col.cmp, col.cnf, model.dat_edt_tmp[i])
      //   }
      //   break
    }
    document.getElementById(model.id).dispatchEvent(new CustomEvent('row_click', { detail: { pservice: this.pservice, model, i } }))
  }

  column_permiter(model: GridModel, col: ColumnModel, row_i: number, mod: number) { // mod=> 1.exist, 2.edt&add
    let stu = 0
    if (model.sta != 3) stu = this.mapping(model, 'status', row_i)

    if (model.prm.cols)
      var pcol = model.prm.cols.find(x => x.vals == '*' || x.vals == col.vals)

    if (pcol && pcol.prmc && (pcol.prmc.statu == null || pcol.prmc.statu.find(x => x == stu) || model.sta == 3)) {
      let c = pcol.prmc
      if (mod == 1 && c.exist == 1) return false
      else if (mod == 2 && ((model.sta == 2 && (c.edit != 2 && c.edit != 4)) || (model.sta == 3 && (c.add != 2 && c.add != 4)))) return false
    }

    return true
  }

  eventer_click_dep(event, model, col_i, row_i, _cform) {
    document.getElementById(model.id + (_cform == 1 ? '' : '1')).dispatchEvent(new CustomEvent('field_click', { detail: { event, model, col_i, row_i } }))
  }

  eventer_change_dep(event: any, model: GridModel, col_i: number, row_i: number, _cform) {
    document.getElementById(model.id + (_cform == 1 ? '' : '1')).dispatchEvent(new CustomEvent('field_change', { detail: { event, model, col_i, row_i } }))
  }

  async eventer(event: any, model: GridModel, key: string, args: any[]) {
    let evt = model.evts.find(x => x.key == key)
    // let ajax = this.ajax
    // let util = this.util
    // let glob = this.glob
    let col_i, col, rowv_i, row, val, _cform
    switch (key) {
      case 'ngIf':
        if (evt.cnf && evt.cnf['key']) {
          return true
          let ret = { result: true }
          await eval(evt.cnf[key])
          return ret.result
        }
        return false
        break;

      case 'filtering_component_click':
      case 'filtering_component_change':
        col = args[0]
        _cform = args[1]
        val = col.flt.val
        break

      case 'filtering_component_keydown':
        col = args[0]
        _cform = args[1]
        // if (col.cmp == 6 && col.flt.val) col.flt.val = col.flt.val.replace('.', ':')
        if (event.key === 'Enter') this.load_assign(model);
        else if (event.key === 'Escape') event.target.value = ''
        break
      case 'data_component_click':
      case 'data_component_change':
        col_i = args[0]
        col = model.cols[args[0]]
        rowv_i = args[1]
        if (model.dats_vis) row = model.dats_vis[args[1]]
        _cform = args[2]
        val = model.dat_edt_tmp[col_i]
        break
      case 'data_component_keydown':
        col_i = args[0]
        col = model.cols[args[0]]
        rowv_i = args[1]
        row = model.dats_vis[args[1]]
        _cform = args[2]
        // if (col.cmp == 6 && model.dat_edt_tmp[col_i]) model.dat_edt_tmp[col_i] = model.dat_edt_tmp[col_i].replace('.', ':')
        if (event.key === 'Enter') { if (col.cmp != 3) this.edit_apply(model, row[0], rowv_i) }
        else if (event.key === 'Escape') this.edit_cancel(model)
        break
      case 'data_row_action':
        evt = args[0]
        rowv_i = args[1]
        row = model.dats_vis[args[1]]
        break
    }
    if (evt == undefined) return
    if (evt.js) {
      if (evt.id != '2020050614553458935' && evt.id != '2020050614553458934') {
        await eval("(async () => {" + evt.js + "})()")
      }
      else {
        let om = this.components.find(x => x.model.id == '2019010209175788343').model // order model
        let odm = this.components.find(x => x.model.id == '2019010209175788344').model // orderdet model
        let g = this.components.find(x => x.model.id == '2020050612171596354').model // goods model
        // if (!odm.dats_vis) odm.dats_vis = []
        let f = odm.dats.find(x => x[2] == row[0])

        if (!f) { // not exist => add
          if (evt.id == '2020050614553458935') { // less button
            this.alerter.warning('این کالا هنوز به لیست افزوده نشده است، لطفا ابتدا از دکمه "افزودن کالا" استفاده نمایید')
            return
          }

          let v: any = 1 // عدد
          if (row[6] != 'عدد') {
            v = prompt('سفارش وزن کالا, لطفا مقدار مورد نظر را به عدد وارد نمایید')
            if (!v || isNaN(parseFloat(v))) {
              this.alerter.warning('مقدار وارد شده معتبر نیست')
              return
            }
            v = parseFloat(v).toFixed(2)
          }
          let d = [{ als: 'order_id', val: om.dat_foc[0] }, { als: 'goods_id', val: row[0] }, { als: 'quantity', val: v }, { als: 'price_consumer', val: row[4] }, { als: 'price_pay', val: row[5] }]
          this.insdate(odm, d, 3, (res) => {
            odm.dats.push([res.id, om.dat_foc[0], row[0], row[2], row[3], row[6], v, row[4], row[5], v * parseInt(row[4]), row[4], row[5]])
            odm.dats_vis = odm.dats
          })
        }

        if (f) { // exist
          if (evt.id == '2020050614553458934') // plus button
          {
            if (row[6] == 'عدد') f[6] = parseInt(f[6]) + 1
            else {
              let v = prompt('سفارش وزن کالا, لطفا مقدار مورد نظر را به عدد وارد نمایید')
              if (!v || isNaN(parseFloat(v))) {
                this.alerter.warning('مقدار وارد شده معتبر نیست')
                return
              }
              f[6] = parseFloat(v).toFixed(2)
            }
            let d = [{ als: 'id', val: f[0] }, { als: 'order_id', val: om.dat_foc[0] }, { als: 'goods_id', val: row[0] }, { als: 'quantity', val: f[6] }]
            this.insdate(odm, d, 2, undefined)
            f[9] = f[6] * f[8]
          }

          if (evt.id == '2020050614553458935') // less button
          {
            if (f[6] <= 1 || row[6] != 'عدد') { // remove
              this.remove(odm, f[0])
            }
            else { // less count
              f[6] = parseInt(f[6]) - 1
              let d = [{ als: 'id', val: f[0] }, { als: 'order_id', val: om.dat_foc[0] }, { als: 'goods_id', val: row[0] }, { als: 'quantity', val: f[6] }]
              this.insdate(odm, d, 2, undefined)
            }
            f[9] = f[6] * f[8]
          }
        }
      }
    }
  }

  eventer_filter_change(event: any, model: GridModel, col: number, _cform) {
    document.getElementById(model.id + (_cform == 1 ? '' : '1')).dispatchEvent(new CustomEvent('field_filter_change', { detail: { event, model, col } }))
  }

  key_down_editing_dep(event: any, model: GridModel, col: ColumnModel, dat: string[], row_i: number) {
    switch (event.key) {
      case 'Enter': if (col.cmp != 3) this.edit_apply(model, dat[0], row_i); break
      case 'Escape': this.edit_cancel(model); break
    }
  }

  key_down_filtering_dep(event: any, model: GridModel) {
    switch (event.key) {
      case 'Enter': this.load_assign(model); break
      case 'Escape': event.target.value = ''; break
    }
  }

  dats_sel_change_all(event: any, model: GridModel) {
    if (event.target.checked) $('#' + model.id).find('input:checkbox:not(:checked)').click()
    else $('#' + model.id).find('input:checkbox:checked').click()
  }

  dats_sel_change(event: any, model: GridModel, dat?: string[]) {
    document.getElementById(model.id).dispatchEvent(new CustomEvent('row_selectable_change', { detail: { model, dat, checked: event.target.checked } }))
  }

  // ------- edit elements events -----------------------------
  select_change(model: GridModel, event: any) {
    let target = event.target
    target.dispatchEvent(new CustomEvent('select_change', { detail: { model, target } }))
    // target.removeEventListener('select_change', undefined)
    // target.addEventListener('select_change', function (e: any) { })
  }

  self_textchange(event: any, col: ColumnModel, mode: string) { // mode => 'fk', 'flt'
    var sbox: any = document.getElementById(col.id + mode)
    let text = event.target.value

    if (mode == 'fk') col.fk.fopts = col.fk.opts.filter(x => x[1] != null && x[1].indexOf(text) != -1)
    else if (mode == 'flt') col.flt.fopts = col.flt.opts.filter(x => x[1] != null && x[1].indexOf(text) != -1)

    if (!sbox.multiple) this.self_open(col, sbox, event.target)
  }

  self_open(col: ColumnModel, sbox, tbox) {
    tbox.value = col.self_search_text ? col.self_search_text : tbox.value
    sbox.multiple = true
    sbox.style.top = '28px'
    sbox.style.visibility = 'visible'
  }

  self_close(event, model: GridModel, col: ColumnModel, ci: number, mode: string) {
    var sbox: any = document.getElementById(col.id + mode)
    sbox.multiple = false
    sbox.style.top = '0px'
    sbox.style.visibility = 'hidden'
    // if (mode == 'fk') model.dat_edt_tmp[ci] = event.target.value.toString()
    // else 
    // if (mode == 'flt') col.flt.val = event.target.value.toString()

    $('#' + col.id + mode + '2').val(sbox.options[sbox.selectedIndex].text)
  }

  self_value(model: GridModel, col: ColumnModel, val: any, mode: string) {
    console.log('self_value', mode)
    var sbox: any = document.getElementById(col.id)
    if (mode == 'fk') return sbox.multiple ? (col.self_search_text || '') : (val && col.fk.fopts && col.fk.fopts.find(x => x[0] == val) ? col.fk.fopts.find(x => x[0] == val)[1] : '')
    else if (mode == 'flt') return sbox.multiple ? (col.self_search_text || '') : (val && col.flt.fopts && col.flt.fopts.find(x => x[0] == val) ? col.flt.fopts.find(x => x[0] == val)[1] : '')
  }

  self_option_change(event, model: GridModel, col, updown: string, mode: string) { // updown=> 'up', 'down', mode: 'fk', 'flt'
    let elem = event.target
    var sbox: any = document.getElementById(col.id + mode)
    let selected = $(sbox).find('option:selected')

    if (!selected || selected.length == 0) $(sbox).find('option:first').attr('selected', 'selected')
    if ((updown == 'down' && selected.val() != $(sbox).find('option:last').val()) || (updown == 'up' && selected.val() != $(sbox).find('option:first').val())) {
      selected.prop('selected', false)
      selected = (updown == 'up' ? selected.prev() : selected.next())
      selected.prop('selected', true)
    }
  }

  self_option_enter(event, model: GridModel, col, ci: number, mode: string) { // mode: 'fk', 'flt'
    document.getElementById(col.id + mode).dispatchEvent(new Event('change'));
    // // setTimeout(() => {
    // var sbox: any = document.getElementById(col.id + mode)
    // sbox.multiple = false
    // sbox.style.top = '0px'
    // $(sbox).val($(sbox).find('option:selected').val())
    // if (col.cmp == 8) model.dat_edt_tmp[ci] = $(sbox).find('option:selected').val().toString()
    // else if (col.cmp == 10) col.flt.val = $(sbox).find('option:selected').val().toString()
    // // model.dat_edt_tmp[ci] = $(sbox).find('option:selected').val().toString()
    // event.target.value = $(sbox).find('option:selected').text()
    // // }, 500)
  }

  upload(event: any, model: GridModel, col: ColumnModel) {
    var upload_data = new FormData()
    upload_data.append('file', event.target.files[0])

    this.ajax.execute({
      url: 'grid/upload/personnel_docs/image_upl/',
      data: upload_data,
      type: 'post',
      contentType: false,
      processData: false,
    })
  }

  uploader_delete(model: GridModel, ci: number, row_id: string) {
    this.ajax.execute({
      url: 'grid/uploader/delete/' + model.tnam + '/' + row_id,
      success: () => {
        this.edit_cancel(model)
      }
    })
  }

  file_browse_click(pad) {
    let file = $('#' + pad)
    file.off('change')
    file.on('change', (event) => {
      $('#' + pad + '_filename').html(file.val().toString().substring(file.val().toString().lastIndexOf('\\') + 1))
    })

    file.trigger('click')
  }

  // ------- utilities ---------------------------------------
  switch_cmptyp(cmp: number, typ: any): any {
    if (cmp == 2)
      switch (typ) {
        case 1: return 'text';
        case 2: return 'number';
        case 3: return 'email';
        case 4: return 'password';
        case 5: return 'color';
        case "text": return 1;
        case "number": return 2;
        case "email": return 3;
        case "password": return 4;
        case "color": return 5;
      }

    if (cmp == 6)
      switch (typ) {
        case 1: return 'day';
        case 2: return 'time';
        case 3: return 'daytime';
        case 4: return 'month';
        case "day": return 1;
        case "time": return 2;
        case "daytime": return 3;
        case "month": return 4;
      }
  }

  switch_cmpcnf_val(cmp: number, cnf: any, val: any): any {
    if (cmp == 6)
      switch (cnf.mod) {
        case 1: return val == null ? null : this.pip.date(parseInt(val), '-').toString()
        case 2: return val == null ? null : this.pip.time(parseInt(val)).toString()
        case 3: return val == null ? null : this.pip.datetime(val).toString()
        case 4: return val == null ? null : this.pip.month(parseInt(val)).toString()
      }

    if (cmp == 8 || cmp == 10 || cmp == 13)
      return val ? val.split('◙')[0] : val

    return val
  }

  switch_fltmod(mod: number): string {
    switch (mod) {
      case 1: return '%'
      case 2: return '='
      case 3: return '/x/'
      case 4: return '[1]'
      case 5: return '[n]'
      case 6: return '<'
      case 7: return '>'
      case 8: return '=<'
      case 9: return '=>'
      case 10: return '!='
      case 11: return '∅'
      case 12: return '!∅'
    }
  }

  validation(model: GridModel, dats: { als: string, val: any }[]) {
    var cols = model.cols
    let mes = ''

    for (let c of cols) {
      if (['id', 'status'].find(x => x == c.vals)) continue
      // if (!(model.sta > 1 && c.tnam == model.tnam && c.edt[this.mapping(model, 'status', row_i)])) continue
      if (!(model.sta > 1 && model.talses.find(y => y == c.tals))) continue
      if (!dat) continue
      var dat = dats.find(x => x.als == c.vals)

      // let stu = this.mapping(model, 'status', model.dat_edt_tmp)
      // if (!model.prm.column.find(x => (x.column_id == '*' || c.id == x.column_id) && (x.statu_id == '*' || x.statu_lev == v))) continue

      if (c.req && !dat.val) mes += `<br>- فیلد ${c.lbl || c.vals} الزامی است`
      else {
        if (c.pat && dat.val && !new RegExp(c.pat).test(dat.val)) mes += `<br>- مقدار فیلد ${c.lbl || c.vals} معتبر نیست`
        if (dat.val && c.cmp == 2 && c.cnf.typ == 2) {
          if (isNaN(dat.val))
            mes += `<br>- مقدار فیلد ${c.lbl || c.vals} عدد نیست`
          else if (c.min && dat.val < c.min)
            mes += `<br>- مقدار فیلد ${c.lbl || c.vals} کمتر از مقدار مجاز است. کمترین مقدار مجاز ${c.min} است`
          else if (c.max && dat.val > c.max)
            mes += `<br>- مقدار فیلد ${c.lbl || c.vals} بیشتر از مقدار مجاز است. بیشترین مقدار مجاز ${c.max} است`
        }
      }
    }
    if (mes == '') return { res: true, mes: null }
    else return { res: false, mes }
  }

  directioner(val, chars?) {
    // if (val && val.length > 0 && (['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '{', '(', '[', '<', "'",].find(x => x == val[0] || x.toUpperCase() == val[0] || (chars && chars.indexOf(val[0]) != -1))))
    if (val && (this.alphabet.find(x => x == val[0])))
      return 'rtl'
    return 'ltr'
  }

  colorer(model, val) {
    if (!val || val == '∅') return 'gray'
    return 'black'
  }

  aligner(val) {
    if (val == '∅') return 'center'
    return 'start'
  }

  cidx = (model: GridModel, als: string) => {
    for (let i = 0; i < model.cols.length; i++)
      if ((model.cols[i].vals) == als)
        return i
    return -1
  }

  mapping = (model: GridModel, als: string, contex: any) => {
    let cid = this.cidx(model, als)
    if (cid == -1) {
      if (als == 'status') return 0
      else { return alert('error mapping: ' + als); }
    }
    try {
      if (typeof contex === 'number') return model.dats_vis[contex][cid]
      else return contex[cid]
    } catch (error) {
    }
  }

  fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    try {
      var successful = document.execCommand('copy')
      var msg = successful ? 'successful' : 'unsuccessful'
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err)
    }

    document.body.removeChild(textArea);
  }

  sumfoot = (model: GridModel, dats: string[][]) => {
    for (let c of model.cols) {
      if (!c.smf) continue
      let i = this.cidx(model, c.vals)
      let res: number = 0
      switch (c.smf) {
        case 'sum':
          for (let d of dats)
            res += parseFloat(d[i]) ? parseFloat(d[i]) : 0
          c.smf_res = this.pip.amount(Math.floor(res))
          break;
        case 'sum_float':
          for (let d of dats)
            res += parseFloat(d[i]) ? parseFloat(d[i]) : 0
          c.smf_res = this.pip.amount(res.toFixed(4))
          break;
        case 'sum_int':
          for (let d of dats)
            res += parseInt(d[i]) ? parseInt(d[i]) : 0
          c.smf_res = this.pip.amount(res)
          break;
        case 'sum_time':
          for (let d of dats)
            res += parseInt(d[i]) ? parseInt(d[i]) : 0
          c.smf_res = this.util.totime(res, false)
          break
        case 'sum_minute':
          for (let d of dats)
            res += parseInt(d[i]) ? parseInt(d[i]) : 0
          c.smf_res = Math.floor(res / 60) + ':' + (res - (Math.floor(res / 60) * 60))
          break
        case 'average':
          for (let d of dats)
            res += parseInt(d[i]) ? parseInt(d[i]) : 0
          c.smf_res = this.pip.amount((res / dats.length).toFixed(2))
          break
        case 'average_time':
          for (let d of dats)
            res += parseInt(d[i]) ? parseInt(d[i]) : 0
          c.smf_res = this.util.totime((res / dats.length), false)
      }
    }
  }

  toquicklist(value) {
    var v = value.split(';')
    for (let i = 0; i < v.length; i++) {
      v[i] = v[i].split('.')
      v[i][0] = parseInt(v[i][0])
    }
    return '{' + JSON.stringify(v) + '}'
  }

  insert_excel_browse(model: GridModel) {
    document.getElementById('insert_excel_' + model.id).click()
  }

  insert_excel(event, model: GridModel) {
    var uploadData = new FormData()
    uploadData.append('file', event.target.files[0])
    uploadData.append('id', model.id)
    uploadData.append('sta', '3')

    if (model.pars && model.pars.find(x => x.length == 4)) return

    if (model.pars)
      for (let i = 0; i < model.pars.length; i++)
        uploadData.append('pars_' + i, model.pars[i][0] + 'ö' + model.pars[i][4])

    this.ajax.execute({
      url: 'grid/insdate_excel',
      data: uploadData,
      type: 'post',
      contentType: false,
      processData: false,
      success: (post) => {
        // for (var i = 0; i < post.alerts.length; i++)
        //   switch (post.alerts[i].t) {
        //     case 0: this.alerter.error(post.alerts[i].m); break;
        //     case 1: this.alerter.warning(post.alerts[i].m); break;
        //     case 2: this.alerter.success(post.alerts[i].m); break;
        //     case 3: this.alerter.info(post.alerts[i].m); break;
        //     case 4: window.location.href = '/account/login'
        //   }
        // for (let x of post.alerts)
        //   if (x.t == 0 || x.t == 1) return

        console.log(post)
        this.load_assign(model)
      }
    })
  }

  deselect(model: GridModel) {
    let g: any = $('#' + model.id + ' tbody tr td:first-child input').prop('checked', false)
    model.dats_sel = []
  }

  change_fltmod(col: ColumnModel, mod: number) {
    col.flt.mod = mod
  }

  modifier(post: any, thos) {
    alert('modifier')
    let grd = post.result.grid[0]
    grd.ssty = this.sanitized.bypassSecurityTrustStyle(grd.sty)
    grd.sstyp = this.sanitized.bypassSecurityTrustStyle(grd.styp)
    grd.ctyp = 'grid'
    grd.cols = []
    if (grd.sela) grd.dats_sel = []
    for (let col of post.result.column) {
      if (grd.id != col.grid_id) continue
      grd.cols.push(col)

      if (col.tals) {
        let tbl = post.result.tbl.find(x => x.als == col.tals)
        if (tbl) {
          col.scm = tbl.scm
          col.tnam = tbl.nam
        }
        else {
          col.scm = null
          col.tnam = null
        }
      }
      if (!col.flt) col.flt = { lod: 1, vis: 1, mod: 1 }
      if (!col.flt.lod && col.flt.lod != 0) col.flt.lod = 1
      if (!col.flt.vis) col.flt.vis = 1
      if (!col.flt.mod) col.flt.mod = 1

      if (col.cmp == 2) {
        if (!col.cnf) col.cnf = { "typ": 1 }
      }
      if (col.cmp == 6) {
        if (!col.cnf) col.cnf = { "mod": 1, "format": "jYYYY-jMM-jDD", "format_out": "jYYYYjMMjDD" }
        if (!col.cnf.mod) col.cnf.mod = 1
        switch (col.cnf.mod) {
          case 2:
            if (!col.cnf.config.format) col.cnf.config.format = 'HH:mm'
            if (!col.cnf.config.format_out) col.cnf.config.format_out = 'sumsec'
            if (col.cnf.config.openOnFocus !== false && col.cnf.config.openOnFucus !== true) col.cnf.config.openOnFocus = false
            if (col.cnf.config.openOnClick !== false && col.cnf.config.openOnClick !== true) col.cnf.config.openOnClick = false
            if (!col.sty) col.sty = 'width: 75px'
            col.cnf.plh = col.cnf.plh || 'hh:mm'
            break
          case 1:
          default:
            if (!col.cnf.config.format) col.cnf.config.format = 'jYYYY-jMM-jDD'
            if (!col.cnf.config.format_out) col.cnf.config.format_out = 'jYYYYjMMjDD'
            // if (!col.sty) col.sty = 'width: 130px'
            col.cnf.plh = col.cnf.plh || 'yyyy-mm-dd'
        }
        if (col.flt.mod == 3) col.flt.val = col.flt.val ? col.flt.val.split('◙') : ['', '']
      }
      if (col.cmp == 8 || col.cmp == 10 || col.cmp == 13) {
        if (!col.fk) col.fk = { lod: 1 }
        if (!col.fk.lod && col.fk.lod != 0) col.fk.lod = 1
        col.pip = `this.slice(val, '◙', 1)`
        if (grd.flt.opts) {
          let op = grd.flt.opts.find(x => x.id == col.id)
          if (op) col.flt.opts = op.opts
        }
      }

      if (col.cmp == 9) col.pip = `this.qlist(val, model.cols[ci].cnf)`
      col.ssty = this.sanitized.bypassSecurityTrustStyle(col.sty)
      col.sstyp = this.sanitized.bypassSecurityTrustStyle(col.styp)
    }

    grd.evts = post.result.event.filter(x => x.grid_id == grd.id)
    for (let a of grd.evts) a.sico = thos.sanitizer.bypassSecurityTrustHtml(a.ico)
    grd.event_dra = post.result.event.filter(x => x.grid_id == grd.id && x.key == "data_row_action")

    if (grd.pars) {
      grd.pars = grd.pars.split(';')
      for (let i: number = 0; i < grd.pars.length; i++)
        grd.pars[i] = grd.pars[i].split(',')
    }
    grd.cols_vis = grd.cols.filter((x: { dis: number; }) => x.dis != 3)
    if (grd.dis == null) grd.dis = 21
    grd.disf = grd.dis - Math.floor(grd.dis / 10) * 10
    grd.dis = Math.floor(grd.dis / 10)
    if (grd.dis == 5 || grd.disf) this.cmodalService.models.push(new CmodalModel('grid', grd.id, grd.tit, grd))
    grd.sta = 1

    // ----- statu -----------------------------
    grd.stus = post.result.statu.filter((x: { tnam: string; }) => x.tnam == grd.scm + '.' + grd.tnam)

    // ----- permit -----------------------
    if (post.result.permit) {
      let prm = post.result.permit
      grd.prm = prm && prm.length > 0 ? prm[0] : null
    }
    return grd
  }

  async popup_select(model: GridModel, col_i: number, out: any, ci: number) {
    let dyn = []

    if (model.cols[col_i].cnf && model.cols[col_i].cnf.dyn) {
      for (let k of model.cols[col_i].cnf.dyn) {
        let a = await this.util.exchange(k[0], { model }, null)
        if (a.err) throw a.err
        let b = await this.util.exchange(k[1], { model }, null)
        if (b.err) throw b.err
        dyn.push([a.res, b.res])
      }
      // dyn = await this.util.exchange(model.cols[col_i].cnf.dyn, {}, null)
    }

    // let opts = model.cols[col_i].cnf.opts
    // let o = model.cols[col_i].cnf.opts ? JSON.parse(model.cols[col_i].cnf.opts) : null
    this.cmodalService.implement(model.cols[col_i].cnf.grd_id, null, dyn, (mdl, dat) => {
      let c = mdl.cols.find(x => ['tit', 'title', 'nam', 'family', 'name', 'als'].find(y => y == x.als))
      let idx = this.cidx(mdl, c.vals)

      if (!idx) {
        alert('گرید انتخابی در popup ستونی نام مستعار زیر ندارد /n tit, title, nam, name, als')
        return
      }
      if (c) out[ci] = dat[0][0] + '◙' + dat[0][idx]
      else out[ci] = dat[0][0] + '◙' + dat[0][0]
    })
  }
}